import React from "react"
import { Avatar } from "../avatar"

export type MenuItemAvatarProps = {
  /** URL for the avatar image */
  avatarUrl?: string
  /** User's display name (used for initials fallback) */
  name?: string
}

export function MenuItemAvatar({ avatarUrl, name }: MenuItemAvatarProps) {
  return <Avatar avatarUrl={avatarUrl} name={name} size="sm" data-slot="menu-item-avatar" />
}

MenuItemAvatar.displayName = "Menu.ItemAvatar"
